import invite from './invite';
import partners from './partners';

export default {
  invite,
  partners,
};



// WEBPACK FOOTER //
// ./src/app/services/marketplaceCustomer/index.js